export default __webpack_public_path__ + "static/media/delete-red.6f32f000.svg";